var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"warning","icon":"fas fa-exclamation"}},[_vm._v(" Sorry, nothing to display here :( ")])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }